import { render, staticRenderFns } from "./manage-sso-mapping.vue?vue&type=template&id=f33ab1b8&scoped=true"
import script from "./manage-sso-mapping.vue?vue&type=script&lang=js"
export * from "./manage-sso-mapping.vue?vue&type=script&lang=js"
import style0 from "./manage-sso-mapping.vue?vue&type=style&index=0&id=f33ab1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33ab1b8",
  null
  
)

export default component.exports